import { AbstractImmutableValueMessage } from "./abstractImmutableValueMessage";

export class DisallowedValueMessage extends AbstractImmutableValueMessage {
   
}